import React from 'react';
import BEM from 'common/bem';

const classes = BEM.with('TypingIndicator');

export default function TypingIndicator() {
  return (
    <div className={classes()}>
      <div className={classes('header')}>
        <div className={classes('avatar')}>
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
          </svg>
        </div>
        <span className={classes('sender')}>TigerConnect Assistant</span>
      </div>
      <div className={classes('bubble')}>
        <span className={classes('dot')} />
        <span className={classes('dot')} />
        <span className={classes('dot')} />
      </div>
    </div>
  );
}
